import { View } from "@/assets/icons";
import { FileItem, IconButton, Panel, Row, RowSize } from "@/components";
import { AttachmentsSummaryProps } from "@/components/attachments-summary/types";
import { NO_VALUE } from "@/constants";
import { selectRequestFormStore, useBoundStore } from "@/services/stores";
import { formatFileSize } from "@/utils";
import { map } from "lodash";
import { FC } from "react";
import styles from "./styles.scss";
import clsx from "clsx";

export const AttachmentsSummaryReview: FC<AttachmentsSummaryProps> = ({
  onPreviewDocument,
}) => {
  const { requestFormData } = useBoundStore(selectRequestFormStore);

  return (
    <Panel header="Attachments">
      {requestFormData?.RequestDocuments
        ? map(requestFormData?.RequestDocuments, (attachment, key) => {
            return (
              <Row
                size={RowSize.Small}
                className={clsx(styles.panelRow, styles.panelRowReview)}
                key={`attachment-${key}`}
              >
                <div className={styles.panelRowTitle}>
                  <span>{attachment?.DocNameEn ?? NO_VALUE}</span>
                </div>
                <div className={styles.panelRowAttr}>
                  {attachment?.name && (
                    <div className={styles.fileName}>
                      <FileItem
                        extension={
                          (attachment.Format?.split(".")[1] ||
                            attachment.Format) ??
                          null
                        }
                        fileName={
                          (attachment.name || attachment?.DocNameEn) ?? NO_VALUE
                        }
                      />
                    </div>
                  )}

                  {attachment?.size && (
                    <div className={styles.panelRowFileSize}>
                      {formatFileSize(attachment?.size)}
                    </div>
                  )}
                  <div>
                    <IconButton
                      icon={View}
                      onClick={() => {
                        onPreviewDocument?.(attachment);
                      }}
                    />
                  </div>
                </div>
              </Row>
            );
          })
        : NO_VALUE}
    </Panel>
  );
};
